import { render, staticRenderFns } from "./ModulesCard.vue?vue&type=template&id=0f76604f&scoped=true"
import script from "./ModulesCard.vue?vue&type=script&lang=js"
export * from "./ModulesCard.vue?vue&type=script&lang=js"
import style0 from "./ModulesCard.vue?vue&type=style&index=0&id=0f76604f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76604f",
  null
  
)

export default component.exports